var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 20.0002C16.4179 20.0002 19.9995 16.4185 19.9995 12.0002C19.9995 7.58191 16.4179 4.00018 11.9997 4.00018C7.5816 4.00018 4 7.58191 4 12.0002C4 16.4185 7.5816 20.0002 11.9997 20.0002Z",
    stroke: "currentColor",
    strokeWidth: 0.898851,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67188 9.60004C9.85995 9.06537 10.2312 8.61453 10.7198 8.32735C11.2084 8.04017 11.7829 7.93519 12.3415 8.03101C12.9001 8.12683 13.4068 8.41726 13.7718 8.85086C14.1368 9.28447 14.3366 9.83326 14.3357 10.4C14.3357 12 11.9358 12.8 11.9358 12.8V14.0857",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H12.0107",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.1b53b93d4f9343821a3414b2d978d392.svg";
export { ForwardRef as ReactComponent };